<div class="dialog container-fluid ps-0">
    <div class="dialog-title">
        <h6 class="pl-3">Checklist Action Items <img src="assets/svg/close-white.svg" alt="close" (click)="close()">
        </h6>
    </div>
    <div class="content pt-0 px-0 ">
        <div class="px-4 my-4 main-tab">
            <mat-table [dataSource]="actionItemsDataSource" matSort class="mat-elevation-z8">

                <!-- Action Item Column -->
                <ng-container matColumnDef="actionItem">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Action Item </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.actionItem}} </mat-cell>
                </ng-container>

                <!-- Action Item Assignee Column -->
                <ng-container matColumnDef="actionItemAssignee">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Assignee </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.actionItemAssignee}} </mat-cell>
                </ng-container>

                <!-- Action Item Due Date Column -->
                <ng-container matColumnDef="actionItemDueDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Due Date </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.actionItemDueDate | date:'mediumDate'}} </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

            </mat-table>
        </div>
    </div>
    <div class="footer pr-0">
        <div class="col-md-12 d-flex button justify-content-end">
            <button class="white mr-2" (click)="close()">Close</button>
        </div>
    </div>
</div>